export default __webpack_public_path__ + "static/media/papabear.6e344792.png";